import React from 'react';
import {Box, Grid, Paper, Typography} from '@mui/material';
import {Celebration, EmojiObjects, People} from '@mui/icons-material';

const features = [
  {
    icon: EmojiObjects,
    title: "Lerne spielerisch",
    description: "Wähle aus vielen spannenden Quizzen oder erstelle deine eigenen. Perfekt für Bildung und Unterhaltung!"
  },
  {
    icon: People,
    title: "Spiele gemeinsam",
    description: "Lade Freunde ein und spielt zusammen in Echtzeit. Mit integriertem Chat und Emoji-Support!"
  },
  {
    icon: Celebration,
    title: "Sammle Erfolge",
    description: "Verfolge deinen Fortschritt, gewinne Spiele und vergleiche dich mit anderen Spielern!"
  }
];

export default function FeatureGrid() {
  return (
    <Grid container spacing={4} sx={{ mt: 4, position: 'relative', zIndex: 1 }}>
      {features.map((feature, index) => (
        <Grid item xs={12} md={4} key={index}>
          <Paper 
            className="glass"
            sx={{ 
              p: 3,
              height: '100%',
              background: 'rgba(28, 39, 60, 0.4)',
              backdropFilter: 'blur(10px)',
              transition: 'all 0.3s ease',
              position: 'relative',
              overflow: 'hidden',
              '&:hover': {
                transform: 'translateY(-5px)',
                '& .feature-icon': {
                  transform: 'scale(1.1) rotate(5deg)'
                },
                '&::after': {
                  opacity: 1
                }
              },
              '&::after': {
                content: '""',
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: 'linear-gradient(135deg, rgba(255,160,0,0.1) 0%, rgba(255,160,0,0) 100%)',
                opacity: 0,
                transition: 'opacity 0.3s ease'
              }
            }}
          >
            <Box sx={{ 
              textAlign: 'center', 
              mb: 2,
              position: 'relative',
              zIndex: 1
            }}>
              {React.createElement(feature.icon, { 
                className: "feature-icon",
                sx: { 
                  fontSize: 40, 
                  color: 'var(--color-secondary)',
                  transition: 'transform 0.3s ease'
                }
              })}
            </Box>
            <Typography 
              variant="h6" 
              gutterBottom 
              sx={{ 
                textAlign: 'center', 
                color: 'var(--color-secondary)',
                position: 'relative',
                zIndex: 1,
                fontSize: '1.25rem'
              }}
            >
              {feature.title}
            </Typography>
            <Typography sx={{ 
              color: 'var(--color-text-secondary)',
              position: 'relative',
              zIndex: 1,
              fontSize: '1rem'
            }}>
              {feature.description}
            </Typography>
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
} 